import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import FormField from '../../forms/FormField';
import { Button } from 'react-bootstrap';

const PasswordResetForm = ({ handleSubmit, submitting, message, password }) => (
  <form onSubmit={handleSubmit}>
    <p>
      Enter a new password, and confirm it to continue.
    </p>
    {message && <div className="login-error">{message}</div>}
    <Field
      required
      name="password"
      type="password"
      component={FormField.Input}
      placeholder="Password"
      validate={[value => value ? undefined : 'Required']}
    />
    <Field
      required
      name="confirmPassword"
      type="password"
      component={FormField.Input}
      placeholder="Confirm Password"
      validate={[
        value => value ? undefined : 'Required',
        value => value === password ? undefined : 'Does not match password'
      ]}
    />
    <Button bsStyle="primary" type="submit" disabled={submitting}>
      Save
    </Button>
  </form>
);

const formName = 'reset-password-form';

const form = reduxForm({
  form: formName,
  touchOnBlur: false // call validation only on submit
})(PasswordResetForm);

const selector = formValueSelector(formName);

const mapState = state => ({
  password: selector(state, 'password')
});

export default connect(mapState)(form);



// WEBPACK FOOTER //
// ./src/components/routes/clientPasswordReset/PasswordResetForm.js